import ERC721AbstractFacade from './ERC721AbstractFacade'
import { DigitalTwinABI } from 'core/constants/DigitalTwin'

export default class ERC721DigitalTwinFacade extends ERC721AbstractFacade<Contract.DigitalTwin> {
  getContractInstance(): Contract.DigitalTwin {
    return new this.web3ForRead.eth.Contract(
      DigitalTwinABI,
      this.contractAddress
    ) as unknown as Contract.DigitalTwin
  }
}
